module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020EN-1.5ce45e83.jpg";